import React, { useState, useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Button } from "primereact/button";
import { motion } from "framer-motion";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { goToTop } from "../../../../../../Components/goToTop";
import { getAppCurrencyType } from "../../../../../../Utils/Common";

import { useAppDispatch, useAppSelector } from "../../../../../../Controllers/hooks";
import {
  ProjectTenderDetailInterface,
  TenderListInterface,
  TenderShareContact,
} from "../../../../../../Controllers/Types/Tender/projectTenderDetailsInterface";
import { getComapareFromTenderList, getProjectTenderDetailList } from "../../../../../../Controllers/Thunks/tenderThunks";
import { BuilderAmount, TenderComparison } from "../../../../../../Controllers/Types/Tender/TenderCompareInterface";
import { selectedTenderListFixed } from "../../../../../../Api/tenderApi";

const TenderComparisonView: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const currencySymbol = getAppCurrencyType();

  const tenderList: TenderListInterface[] = location.state
    .tenderList as TenderListInterface[];
  const tenderpart: ProjectTenderDetailInterface = location.state
    .tenderpart as ProjectTenderDetailInterface;

  const [loginUserRoleName, setLoginUserRoleName] = useState<string>("");


  /* Company */
  const [buildersList, setbuildersList] = useState<TenderShareContact[]>([]);

  /* Fix price */
  const [showFixPriceModal, setShowFixPriceModal] = useState<boolean>(false);
  const [selectedBuilder, setSelectedBuilder] = useState<number | null>(null);

 // login user type name.
  useEffect(() => {
    const fetchUserRoleName = async () => {
      try {
        const userTypeName = await Promise.resolve(
          localStorage.getItem("user_type_name")
        );

        if (userTypeName) {
          setLoginUserRoleName(userTypeName.toLowerCase());
        } else {
          setLoginUserRoleName("");
        }
      } catch (error) {
        setLoginUserRoleName("");
        
      }
    };

    fetchUserRoleName();
  }, []);




  useEffect(() => {
    const data:any = {
      id: tenderpart.project_tender_part_id,
      list: tenderList,
    };
   
    dispatch(getComapareFromTenderList(data));
  }, [location.state]);


  // this is get data from state list and set projectlist
  const compareList = useAppSelector(
    (state) => state.tenderCompareList.compareList
  );



  useEffect(() => {
    const contactlist=tenderpart.share_contact;
    if(contactlist && contactlist.length>0){
        const builderlist=contactlist.filter((e)=>tenderList.filter((ex)=>e.tender_part_share_id===ex.tender_part_share_id).length>0);

        if(builderlist && builderlist.length>0){
            setbuildersList(builderlist);
        }
    }
  }, [tenderpart]); 


  const [tenderComparision, setTenderCompariosonData] = useState<
    TenderComparison[]
  >([]);

//   set tender comparation data as well.
  useEffect(() => {
      if (compareList?.length !== 0) {
        setTenderCompariosonData(compareList);
      }
  }, [compareList]);

  const [expandedSection, setExpandedSection] = useState<number | null>(null);
  const [expandedSubSection, setExpandedSubSection] = useState<number | null>(
    null
  );

  /* ******************************** Table view ******************************** */
  const toggleSection = (sectionId: number) => {
    setExpandedSection((prev) => (prev === sectionId ? null : sectionId));
    setExpandedSubSection(null);
  };

  const toggleSubSection = (subSectionId: number) => {
    setExpandedSubSection((prev) =>
      prev === subSectionId ? null : subSectionId
    );
  };

  const renderBuilderAmount = (
    amounts: BuilderAmount[] | undefined,
    builderId: number
  ) => {
    if (!amounts) return currencySymbol + "0.00";
    const builderData = amounts.find(
      (amount) => parseInt(amount.tender_part_share_id, 10) === builderId
    );
    if (!builderData) return currencySymbol + "0.00";

    const className = builderData.is_min ? "text-red" : "";
    const icon = builderData.is_min ? <span>↓</span> : null;

    return (
      <span className={className}>
        {currencySymbol}&nbsp;{builderData.amount.toFixed(2)} {icon}
      </span>
    );
  };

  const renderSectionRows = () => {
    return tenderComparision.map((section) => {
      const isExpanded = expandedSection === section.section_id;

      const hasSubSectionData =
        section.sub_section_data && section.sub_section_data.length > 0;
      const hasSectionItemData =
        section.section_item_data && section.section_item_data.length > 0;

      const canExpand = hasSubSectionData || hasSectionItemData;

      return (
        <React.Fragment key={section.section_id}>
          <tr>
            <td colSpan={2} className="section_name">
              {section.section_no}. {section.section_name}
            </td>
            {buildersList.map((builder) => (
              <td key={builder.id} className="text-center">
                {renderBuilderAmount(
                  section.section_builder_amount,
                  builder.tender_part_share_id
                )}
              </td>
            ))}
            <td className="row_expansion_btn_area">
              {canExpand && (
                <button
                  type="button"
                  onClick={() => toggleSection(section.section_id!)}
                  className="row_expansion_btn is_btn"
                >
                  <i
                    className={`bi ${
                      isExpanded ? "bi-chevron-up" : "bi-chevron-down"
                    }`}
                  ></i>
                </button>
              )}
            </td>
          </tr>
          {isExpanded &&
            hasSubSectionData &&
            section.sub_section_data!.map((subSection) => {
              const isSubSectionExpanded =
                expandedSubSection === subSection.sub_section_id;

              const canExpandSubSection =
                subSection.sub_section_item_data &&
                subSection.sub_section_item_data.length > 0;

              return (
                <React.Fragment key={subSection.sub_section_id}>
                  <motion.tr
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="section_content_row"
                  >
                    <td
                      style={{ paddingLeft: "15px" }}
                      className="section_content_number number_area"
                    >
                      {subSection.sub_section_no}.
                    </td>
                    <td className="section_content_number">
                      {subSection.sub_section_name}
                    </td>
                    {buildersList.map((builder) => (
                      <td key={builder.id} className="text-center">
                        {renderBuilderAmount(
                          subSection.sub_section_builder_amount,
                          builder.tender_part_share_id
                        )}
                      </td>
                    ))}
                    <td className="row_expansion_btn_area">
                      {canExpandSubSection && (
                        <button
                          type="button"
                          onClick={() =>
                            toggleSubSection(subSection.sub_section_id!)
                          }
                          className="row_expansion_btn is_btn"
                        >
                          <i
                            className={`bi ${
                              isSubSectionExpanded
                                ? "bi-chevron-up"
                                : "bi-chevron-down"
                            }`}
                          ></i>
                        </button>
                      )}
                    </td>
                  </motion.tr>
                  {isSubSectionExpanded &&
                    subSection.sub_section_item_data &&
                    subSection.sub_section_item_data.map((item) => (
                      <motion.tr
                        key={item.item_id}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        className="sub_section_item_row"
                      >
                        <td
                          style={{ paddingLeft: "30px" }}
                          className="number_area sub_section_item_number"
                        >
                          {item.item_no}.
                        </td>
                        <td className="sub_section_item_name">
                          {item.item_name}
                        </td>
                        {buildersList.map((builder) => (
                          <td key={builder.id} className="text-center">
                            {renderBuilderAmount(
                              item.item_builder_amount,
                              builder.tender_part_share_id
                            )}
                          </td>
                        ))}
                        <td></td>
                      </motion.tr>
                    ))}
                </React.Fragment>
              );
            })}
          {isExpanded &&
            hasSectionItemData &&
            section.section_item_data!.map((item) => (
              <motion.tr
                key={item.item_id}
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                className="section_content_row"
              >
                <td
                  style={{ paddingLeft: "15px" }}
                  className="number_area section_content_number"
                >
                  {item.item_no}.
                </td>
                <td className="section_content_name section_item">
                  {item.item_name}
                </td>
                {buildersList.map((builder) => (
                  <td key={builder.id} className="text-center">
                    {renderBuilderAmount(item.builder_amount, builder.tender_part_share_id)}
                  </td>
                ))}
                <td></td>
              </motion.tr>
            ))}
        </React.Fragment>
      );
    });
  };
  /* **************************************************************************** */

  /* ******************************** Fix price ******************************** */
  const handleFixPriceTenderList = () => {
    setShowFixPriceModal(true);
  };

   // fixed price action and navigate -2
  const handleFixPrice = async() => {
          const res = await selectedTenderListFixed(
           selectedBuilder!,
          );
          if (res.status) {
            dispatch(getProjectTenderDetailList(tenderpart.folder_id));
            setShowFixPriceModal(false);
            navigate(-2);
          } 
  };



  const handleCloseFixPriceModal = () => {
    setShowFixPriceModal(false);
  };

  /* Fix price modal header */
  const fixPriceModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Fix the price</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseFixPriceModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  /* fix price modal footer */
  const fixPriceModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label={`Save`}
        onClick={handleFixPrice}
        className="custom_btn primary"
        disabled={selectedBuilder === null}
      />
    </div>
  );

  const handleSelectToFixPrice = (id: number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedBuilder(id);
    } else {
      setSelectedBuilder(null);
    }
  };

  const isSelectedBuilder = (id: number) => selectedBuilder === id;
  /* **************************************************************************** */

  /* **************************** Common functions ***************************** */
  const formatPrice = (value: number) => {
    return new Intl.NumberFormat("en-UK", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <div>
      <div className="project_toolbar no_side_bar">
        <div className="project_tool_options flex-row">
          <div className="project_tool_options_sub">
           
           {(loginUserRoleName === "architect" ||
                loginUserRoleName === "commercial client")&&(<button
              className={`is_btn project_tool_btn p-ripple`}
              onClick={handleFixPriceTenderList}
            >
              Fix price
              <Ripple />
            </button>)} 

          </div>

          <div className="project_tool_options_sub">
            <button
              className={`is_btn project_tool_btn p-ripple`}
              onClick={goBack}
            >
              Back
              <Ripple />
            </button>
          </div>
        </div>
      </div>

      <div className={`project_main_content no_side_bar`}>
        <article id="content" className="main_section_area">
          <div className="tender_compare_table_area">
            <div className="table-responsive">
              <table className="table table-hover tender_compare_table">
                <thead>
                  <tr>
                    <th colSpan={2} className="section_name_head">
                      Section name
                    </th>
                    {buildersList.map((builder) => (
                      <th
                        key={builder.id}
                        className="builder_name_head text-center"
                      >
                        {(builder.company_name!==null)?builder.company_name:builder.first_name}
                      </th>
                    ))}
                    <th className="row_expansion"></th>
                  </tr>
                </thead>
                <tbody>{renderSectionRows()}</tbody>
              </table>
            </div>
          </div>
        </article>
      </div>

      {/* Fix price modal */}
      <Dialog
        visible={showFixPriceModal}
        header={fixPriceModalHeader}
        footer={fixPriceModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_md"
        dismissableMask
        onHide={handleCloseFixPriceModal}
      >
        <div className="custom_modal_body">
          <div className="p-1">
            <div className="row">
              <div className="col-12">
                <label className={`custom_form_label mb-2`}>
                  Select builder
                </label>
                {buildersList?.map((builder) => (
                  <div className="option_checkbox_area" key={builder.tender_part_share_id}>
                    <article
                      className={`shared_contact_body mb-0 ${
                        isSelectedBuilder(builder.tender_part_share_id!) && "selected"
                      }`}
                    >
                      <h6>  {(builder.company_name!==null)?builder.company_name:builder.first_name}</h6>
                    </article>
                    <Checkbox
                      onChange={(e) =>
                        handleSelectToFixPrice(builder.tender_part_share_id!, e.checked || false)
                      }
                      checked={isSelectedBuilder(builder.tender_part_share_id!)}
                    ></Checkbox>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default TenderComparisonView;
